import { Component } from '@angular/core';
import { AppService } from '@services/app.service';

@Component({
  selector: 'app-admin-home',
  standalone: true,
  imports: [],
  templateUrl: './admin-home.component.html',
  styleUrl: './admin-home.component.scss'
})
export class AdminHomeComponent {

  constructor(
    private appService: AppService
  ){}

  logout(){
    this.appService.logout();
  }
}
